import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Container from "react-bootstrap/Container";
import seo from "./helpers/seo";

class Closing extends React.Component {
  componentDidMount() {
    seo({
      title: "Closing",
    });
  }

  render() {
    return (
      <React.Fragment>
        <Header />
        <Container className="policies content">
          <div>
            <h1>A Heartfelt Goodbye from The Olde Barber Cannabis Co.</h1>
            <br />
            <h2>
              <span style={{ color: "red" }}>CLOSING MAY 31, 2025</span>
            </h2>
            <h2>
              <span style={{ color: "red" }}>Open Everyday 12pm-7pm</span>
            </h2>
            <br />
            <p>Dear Valued Customers and Friends,</p>
            <p>
              It is with a heavy heart that I'm writing to announce the closure
              of The Olde Barber Cannabis Co. Our last day of business will be{" "}
              <strong>May 31, 2025</strong>. Over the past years, we've had the
              privilege of being part of this wonderful community in Cobalt. The
              connections we've made and the relationships we've built have been
              the most rewarding part of this journey. Every conversation, every
              laugh shared, and every moment spent getting to know you has been
              truly special.
            </p>
            <br />
            <h2>Why We're Closing</h2>
            <p>
              Unfortunately, circumstances beyond our control have forced us to
              make this difficult decision. Following a break-in last year, our
              insurance company initially attempted to deny our claim. After an
              8-month battle, they eventually paid out the claim but have now
              refused to renew our policy, citing the claim itself as the
              reason.
            </p>
            <p>
              Despite having 60 days' notice and working with multiple brokers,
              we've been unable to secure new coverage due to this claim on our
              record - something that was no fault of our own. As cannabis
              retail regulations require proper insurance coverage to operate,
              we are left with no choice but to close our doors.
            </p>
            <br />
            <h2>Farewell Sale</h2>
            <p>
              As we prepare to say goodbye, we invite you to take advantage of
              our closing sale:
            </p>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>
                    <strong>Date Range</strong>
                  </th>
                  <th>
                    <strong>Discount</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>May 10-16</strong>
                  </td>
                  <td>
                    <strong>15% OFF Everything</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>May 19-31</strong>
                  </td>
                  <td>
                    <strong>25% OFF Everything</strong>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <h2>Enter to Win a Volcano Classic!</h2>
            <p>
              To show our appreciation, we're giving away a{" "}
              <strong>Volcano Classic vaporizer</strong> from Storz & Bickel!
              Every time you visit our store between now and closing, you'll be
              automatically entered into the drawing. No purchase necessary to
              enter - just stop by to say hello and you'll be entered to win.
              The winner will be drawn on June 1st.
            </p>
            <br />
            <h2>A Personal Thank You</h2>
            <p>
              From me, Aunum, and the entire team at The Olde Barber Cannabis
              Co., I want to express my deepest gratitude for your support
              throughout our time in business. It has been an honor to serve
              this community, and I truly appreciate each and every one of you
              who walked through our doors.
            </p>
            <p>
              <strong>Our Hours Until Closing: Open Everyday 12pm-7pm</strong>
            </p>
            <p>
              Please come visit us during these final weeks. I'd love the chance
              to thank you in person and say a proper goodbye.
            </p>
            <p>With sincere appreciation,</p>
            <p>
              Aunum
              <br />
              The Olde Barber Cannabis Co.
              <br />
              33 Silver St., Cobalt, ON
            </p>
            <hr />
            <p className="contest-rules">
              <em>
                Contest Rules: No purchase necessary to enter. One entry per
                visit per day. Must be 19+ to enter. Winner will be drawn
                randomly on June 1, 2025, and contacted via provided contact
                information. Complete contest rules available in-store.
              </em>
            </p>
          </div>
        </Container>
        <Footer />
      </React.Fragment>
    );
  }
}

export default Closing;
